export default function expandTable(editor, tableId) {
  return editor.withoutNormalizing(function () {
    editor.getTableCells(tableId).forEach(function (cell) {
      return editor.setNodeByKey(cell.key, {
        data: cell.data.set('isExpanded', true)
      });
    });
  });
}